import React from 'react'

export const options = {
    columns: [
        { id: 1, name: '', label: '', sortable: false, },
        { id: 1, name: 'id', label: 'PLAN ID', sortable: false, },
        { id: 2, name: 'name', label: 'PLAN NAME', sortable: true, type: 'string',},
        { id: 2, name: 'displayName', label: 'DISPLAY NAME', sortable: true, type: 'string' },
        { id: 3, name: 'planType', label: 'PLAN TYPE', sortable: false, type: 'string', component: (row) => <div>{row.planType == "1" ? "Normal" : row.planType == "2" ? "Custom" :'-'}</div> },
        { id: 4, name: 'currencySupported', label: 'CURRENCY SUPPORTED', sortable: false, type: 'number' },
        { id: 5, name: 'countrySupported', label: 'COUNTRY SUPPORTED', sortable: false, type: 'number', },
        { id: 6, name: 'tenantSupported', label: 'TENANT SUPPORTED', sortable: false, type: 'string' },
        { id: 7, name: 'cost', label: 'AMOUNT', sortable: false, type: 'number',  component: (row) => <div>{row.cost  ? row.cost.toFixed(2) : '-'}</div> },
        { id: 8, name: 'offerType', label: 'OFFER', sortable: false, type: 'number', component: (row) => <div>{row.offerType == "0" ? "NA" : row.offerType == "1" ? "IN %" :'Fix'}</div> },
        { id: 9, name: 'outage', label: 'OUTAGE %', sortable: false, type: 'number',  component: (row) => <div>{row.outage  ? row.outage.toFixed(2) : '-'}</div> },
        { id: 10, name: 'spentLimitType', label: 'SPEND LIMIT', sortable: false, type: 'number', component: (row) => <div>{row.spentLimitType == "0" ? "Limited" : row.spentLimitType == "1" ? "Unlimited" :'-'}</div> },
        { id: 11, name: 'duration', label: 'DURATION (in days)', sortable: false, type: 'number', },
        { id: 12, name: 'startDate', label: 'START DATE', sortable: false, type: 'number', },
        { id: 13, name: 'endDate', label: 'END DATE', sortable: false, type: 'number', },
        { id: 14, name: 'displaySupported', label: 'DISPLAY SUPPORTED', sortable: false, type: 'number', component: (row) => <div>{row.displaySupported == "1" ? "YES" : row.displaySupported == "0" ? "NO" :'-'}</div> },
        { id: 15, name: 'status', label: 'STATUS', sortable: false, type: 'number',  component: (row) => <div>{row.status == "1" ? "Active" : row.status == "2" ? "Draft" :'Inactive'}</div>},
    ],
    keyCol: 'ioNo',
    actionName: 'ACTIONS',
    actions: [
        {
            type: 'edit',
            text: '',
            icon: 'ti ti-pencil color-beki',
            tooltip: 'Edit',
            iconType: 'new'
          },
    ],
    recActive: false,
    actionsThead: true,
    sortable: true,
    dateType: true,
    defaultSortParams: {
        sortBy: 'txnDateTime',
        sortOrder: 'desc'
    },
    paging: true,
    defaultPagingParams: {
        pageSize: 25
    }
};

export const planTypeOptions = [
    { value: 'null', label: 'All' },
    { value: '1', label: 'Standard' },
    { value: '2', label: 'Custom' },
  ]



